import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  container: {
    margin: '12px 0',
  },
  icon: {
    marginRight: 15,
    height: '100%',
  },
  errorTextContainer: {
    width: '100%',
  },
  errorText: {
    fontWeight: 300,
    textAlign: 'justify',
  },
  linkIcon: {
    width: '12px !important',
    height: 12,
  },
  detailsButtonContainer: {
    marginLeft: 10,
    backgroundColor: '#EEEEEE',
    borderRadius: theme.new.sizings.border,
    minWidth: 35,
    width: 35,
    minHeight: 35,
    height: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  detailsButton: {
    minWidth: 0,
    borderRadius: theme.new.sizings.border,
    height: '100%',
  },
  category: {
    fontWeight: 700,
    fontSize: 12,
  },
}));
